import { Routes } from '@angular/router';
import { AuthGuard } from 'app/guards/auth-guard';
import { RoleGuard } from 'app/guards/role-guard';

// Define routes specific to the RD Manager role
export const hrManagerRoutes: Routes = [
  {
    path: 'dashboard',
    loadComponent: () =>
      import('@pages/hr-manager/hr-dashboard/hr-dashboard').then(
        (m) => m.HrDashboard
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
    },
  },
  {
    path: 'recruitment-management',
    loadComponent: () =>
      import(
        '@pages/hr-manager/recruitment-management/recruitment-management'
      ).then((m) => m.RecruitmentManagement),
    data: {
      isSidebar: 1,
      isHeader: 1,
    },
  },
  {
    path: 'recruitment-management/details/:id/:project-method',
    loadComponent: () =>
      import(
        '@pages/hr-manager/recruitment-management/recruitment-details/recruitment-details'
      ).then((m) => m.RecruitmentDetails),
    data: {
      isSidebar: 1,
      isHeader: 1,
    },
  },
  {
    path: 'recruitment-management/interviewer-list',
    loadComponent: () =>
      import(
        '@pages/hr-manager/recruitment-management/interviewer-list/interviewer-list'
      ).then((m) => m.InterviewerList),
    data: {
      isSidebar: 1,
      isHeader: 1,
    },
  },
  {
    path: 'user-management',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import('@pages/hr-manager/user-management/user-management').then(
        (m) => m.UserManagement
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'HR',
    },
  },
  {
    path: 'user-management/add-user',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import('@pages/hr-manager/user-management/add-user/add-user').then(
        (m) => m.AddUser
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'HR',
    },
  },
  {
    path: 'user-management/add-user/:id',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import('@pages/hr-manager/user-management/add-user/add-user').then(
        (m) => m.AddUser
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'HR',
    },
  },
];
